// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { LocationModel } from "@insite/client-framework/Common/Hooks/useLocationFilterSearch";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface XVmiLocationModel extends LocationModel {
    websiteUrl: string;
    isPickupLocation: string;
    content: string;
}

export type VmiLocationsState = Readonly<{
    isLoading: boolean;
    locations: XVmiLocationModel[];
}>;

export const initialXVmiLocations: VmiLocationsState = {
    isLoading: false,
    locations: [],
};

const reducer = {
    "xVmiLocations/SetLoading": (draft: Draft<VmiLocationsState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
    },
    "xVmiLocations/CompleteLoad": (draft: Draft<VmiLocationsState>, action: { locations: XVmiLocationModel[] }) => {
        draft.isLoading = false;
        draft.locations = action.locations;
    },
};

const xVmiLocations = createTypedReducerWithImmer(initialXVmiLocations, reducer);
(reducers as any).xVmiLocations = xVmiLocations;

export type XVmiLocationsState = {
    xVmiLocations: VmiLocationsState;
} & ApplicationState;

type XVmiLocationsReducers = {
    [key: string]: typeof xVmiLocations;
};

export type XVmiLocationsActions = Parameters<XVmiLocationsReducers[keyof XVmiLocationsReducers]>[1] | AnyAction;
